import useIsRole from './useIsRole'

export default () => useIsRole('superadmin')
